
import React, { Component } from 'react'


// Route Imports
import { Link } from 'react-router-dom';

// Material UI Imports
import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import pink from "@material-ui/core/colors/pink";
import orange from "@material-ui/core/colors/orange";

// Material Icons Imports
import IconFileFolder from '@material-ui/icons/Folder';

// Assets imports

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';


const orange200 = orange['200'];
const pink400 = pink['400'];

const styles = {
    avatar: {
        size: 30,
        margin: 10,
        color: orange200,
        backgroundColor: pink400,
    },
};

class Project extends Component {
    // constructor(props) {
    //     super(props);

    // };
    render() {
        const { classes } = this.props;

        return (
            <ListItem
                component={Link}
                to={`/projects/${this.props.project.id}/print`}
            >
                <Avatar
                    className={classes.avatar}
                ><IconFileFolder /></Avatar>
                <ListItemText primary={this.props.project.name} secondary={this.props.project.number.toString()} />
            </ListItem>
        );
    }
}

Project.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Project)


// WEBPACK FOOTER //
// src/components/innerComponents/Project.js